/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_Generating_Audio_PreviewInputs */

const en_load_project_file_status_generating_audio_preview = /** @type {(inputs: Load_Project_File_Status_Generating_Audio_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating audio preview...`)
};

const fr_load_project_file_status_generating_audio_preview = /** @type {(inputs: Load_Project_File_Status_Generating_Audio_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generation de l'apercu audio...`)
};

const de_load_project_file_status_generating_audio_preview = /** @type {(inputs: Load_Project_File_Status_Generating_Audio_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio-Vorschau wird generiert...`)
};

const it_load_project_file_status_generating_audio_preview = /** @type {(inputs: Load_Project_File_Status_Generating_Audio_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione dell'anteprima audio...`)
};

const ru_load_project_file_status_generating_audio_preview = /** @type {(inputs: Load_Project_File_Status_Generating_Audio_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание предварительного аудиофайла...`)
};

const es_load_project_file_status_generating_audio_preview = /** @type {(inputs: Load_Project_File_Status_Generating_Audio_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando vista previa de audio...`)
};

const zh_cn2_load_project_file_status_generating_audio_preview = /** @type {(inputs: Load_Project_File_Status_Generating_Audio_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在生成音频预览...`)
};

const ja_load_project_file_status_generating_audio_preview = /** @type {(inputs: Load_Project_File_Status_Generating_Audio_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオプレビューを生成しています...`)
};

const hi_load_project_file_status_generating_audio_preview = /** @type {(inputs: Load_Project_File_Status_Generating_Audio_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो पूर्वावलोकन तैयार किया जा रहा है...`)
};

const pt_pt2_load_project_file_status_generating_audio_preview = /** @type {(inputs: Load_Project_File_Status_Generating_Audio_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerando pré-visualização de áudio...`)
};

/**
* | output |
* | --- |
* | "Generating audio preview..." |
*
* @param {Load_Project_File_Status_Generating_Audio_PreviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_generating_audio_preview = /** @type {((inputs?: Load_Project_File_Status_Generating_Audio_PreviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_Generating_Audio_PreviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_load_project_file_status_generating_audio_preview(inputs)
	if (locale === "de") return de_load_project_file_status_generating_audio_preview(inputs)
	if (locale === "it") return it_load_project_file_status_generating_audio_preview(inputs)
	if (locale === "ru") return ru_load_project_file_status_generating_audio_preview(inputs)
	if (locale === "es") return es_load_project_file_status_generating_audio_preview(inputs)
	if (locale === "zh-CN") return zh_cn2_load_project_file_status_generating_audio_preview(inputs)
	if (locale === "ja") return ja_load_project_file_status_generating_audio_preview(inputs)
	if (locale === "hi") return hi_load_project_file_status_generating_audio_preview(inputs)
	if (locale === "pt-PT") return pt_pt2_load_project_file_status_generating_audio_preview(inputs)
	return en_load_project_file_status_generating_audio_preview(inputs)
});